import React from "react"

import { SmartMatchingDataPerson } from "~/SmartMatching/SmartMatchingContext"
import SmartMatchScoreLabel from "~/SmartMatching/SmartMatchingScoreLabel"

import styles from "./MatchDetailTab.module.css"

type Props = {
  smartMatchingData: SmartMatchingDataPerson
}

const MatchDetailTab = ({ smartMatchingData }: Props) => {
  return (
    <div className={styles.container}>
      <SmartMatchScoreLabel
        score={smartMatchingData.totalScore}
        size="large"
        className={styles.overallScore}
      />
    </div>
  )
}

export default MatchDetailTab
